export default "/images/0789c6c0b138c7a0c38e3d0aef71aef4.avif";